export const locale = {
    lang: 'pl',
    data: {
        'New category': 'Nowa kategoria',
        'Name': 'Nazwa',
        'Parent category': 'Nadrzędna kategoria',
        'ADD': 'Dodaj',
        'Are you sure you want to delete selected group?': 'Czy na pewno chcesz usunąć wybraną grupę?',
        'Confirm deletion': 'Potwierdź usunięcie',
        'Cancel': 'Anuluj',
        'CANCEL': 'Anuluj',
        'Confirm': 'Potwierdź',
    }
};
